export const saveToken = token => localStorage.setItem('token', JSON.stringify({ token, date: new Date() }));

export const getTokenData = () => {
  const token = localStorage.getItem('token');
  return JSON.parse(token);
};

export const isLoggedIn = () => isTokenValid(getTokenData());

export const removeToken = () => localStorage.removeItem('token');

export const isTokenValid = tokenData => !!tokenData;
